import { Autocomplete } from "@react-google-maps/api";
import { FiltersCard } from "@shared/cards";

interface ExploreFiltersOffcanvasProps {
  isLoaded: boolean;
  autoCompleteLocation: string;
  setAutoCompleteLocation: (location: string) => void;
  onLoadState: (autocomplete: any) => void;
  onStateChanged: () => void;
  page: number;
  limit: number;
  setPage: (page: number) => void;
  setFiltersLoaded: (loaded: boolean) => void;
}

export const ExploreFiltersOffcanvas = ({
  isLoaded,
  autoCompleteLocation,
  setAutoCompleteLocation,
  onLoadState,
  onStateChanged,
  page,
  limit,
  setPage,
  setFiltersLoaded,
}: ExploreFiltersOffcanvasProps) => {
  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex={-1}
      id="offcanvasExample"
      aria-labelledby="offcanvasExampleLabel"
    >
      <div className="offcanvas-header px-4">
        <h5 className="offcanvas-title fw-bolder" id="offcanvasExampleLabel">
          Filters
        </h5>
        <button
          type="button"
          className="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>

      <FiltersCard
        isLoaded={isLoaded}
        autoCompleteLocation={autoCompleteLocation}
        setAutoCompleteLocation={setAutoCompleteLocation}
        Autocomplete={Autocomplete}
        onLoadState={onLoadState}
        onStateChanged={onStateChanged}
        page={page}
        limit={limit}
        setPage={setPage}
        setFiltersLoaded={setFiltersLoaded}
      />
    </div>
  );
};
